import * as Types from 'Models/ViewManagementModel';
import * as ViewManagementActions from './../Store/Actions/ViewManagementActions';

export { Types, ViewManagementActions as Actions };



// WEBPACK FOOTER //
// ./src/Modules/ViewManagementModule.ts